import { Text, VSpacing } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

import styles from './styles.less';

const TrlKeys = {
    corrected: 'employer.resumesSearch.nigmer.corrected',
    nothing: 'employer.resumesSearch.nigmer.nothing',
};

const QueryFixer: TranslatedComponent = ({ trls }) => {
    const originalQuery = useSelector((state) => state.resumeSearchResult?.fixes?.text?.original);
    if (!originalQuery) {
        return null;
    }

    return (
        <>
            <VSpacing default={8} />
            <Text typography="label-2-regular">
                {trls[TrlKeys.corrected]}
                <span className={styles.originalQuery}>{originalQuery}</span>
                {trls[TrlKeys.nothing]}
            </Text>
        </>
    );
};

export default translation(QueryFixer);
